<template>
    <v-menu
            v-model="menu"
            :close-on-content-click="false"
            offset-y
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                    :required="required"
                    @focus="focused"
                    v-model="content"
                    v-on="on"
                    :placeholder="label"
                    :height="28"
                    hide-details
                    :error-messages="valid() == true ? null : [valid()] "
                    @blur="blur"
                    :dense="!old"
                    :label="label"
                    :outlined="!old"
                ></v-text-field>
            </template>
            <v-date-picker :value="content" @input="updateSelf"></v-date-picker>
        </v-menu>
</template>

<script>
export default {
  name: "BookingDateInput",
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    error: String,
    old: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    blur() {
      var vm = this;

      setTimeout(function() {
        console.log("Blur " + vm.content);
        vm.$emit("input", vm.content);
      }, 200);
    },
    valid() {
      console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    updateSelf(content) {
      this.menu = false;

      this.content = content;
      this.$emit("submitted");

      this.$emit("input", content);
      console.log("date selected");
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
